export default "__VITE_ASSET__DqWOd3on__"